import {Button} from "antd";
import React from "react";
import arrowBack from "../../../../assets/images/arrow-left.svg";
import visa from '../../../../assets/images/visa.svg';
import {OfferValue} from "../../../../core/models/custom/offerValue";
import {CardDto} from "../../../../core/models/dtos/card.dto";
import FirebaseService from "../../../../core/services/firebaseService/firebase.service";
import FirebaseKey from "../../../FirebaseKey/FirebaseKey";
import Loading from "../../../Loading/Loading";
import "./SavedCard.scss";

interface IProps {
  isNewcomer: boolean;
  offer: OfferValue;
  card: CardDto;
  isLoading: boolean;
  isLoadingCardDelete: boolean;
  callbackDelete: () => void;
  callbackApproval: (card?: CardDto) => void;
}

const SavedCard = (props: IProps) => {
  
  function handleContinue(): void {
    FirebaseService.logEvent(FirebaseService.getContinue(props.offer.id));
    props.callbackApproval(props.card);
  }
  
  return (
    <div id="saved-card">
      <div className="saved-card-title">
        <FirebaseKey firebaseKey={FirebaseService.cc_saved_cards}/>
      </div>
      <div className="saved-card-content">
        <img className="visa" src={visa} alt="visa"/>
        <span className="masked-pan">{props.card.maskedPan}</span>
        {
          props.isLoadingCardDelete
            ?
            <Loading/>
            :
            <span
              className="button"
              onClick={() => {
                if (!props.isLoading) {
                  props.callbackDelete()
                }
              }}
            >
              kaldır
            </span>
        }
      </div>
      <div className="buttons">
        {
          props.isNewcomer &&
          <Button
            className="app-button secondary"
            disabled={props.isLoading}
            onClick={() => props.callbackApproval()}
          >
            <img src={arrowBack} alt="arrow"/>
          </Button>
        }
        <Button
          className="app-button"
          disabled={props.isLoading}
          onClick={() => handleContinue()}
        >
          {props.isLoading ? <Loading fontSize={20}/> : props.isNewcomer ? 'KAZAN' : 'DEVAM ET'}
        </Button>
      </div>
    </div>
  );
}

export default SavedCard;
